import { Controller } from "@hotwired/stimulus"

// Highlights the selected country pill and lets the form's
// data-turbo-confirm fire only when the country actually changed.
// The base submit attribute always asks for confirmation; we strip it
// when the country pill matches what was originally rendered, so users
// editing the timezone alone aren't prompted.
export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { current: String }

  connect() {
    this.syncConfirm()
  }

  confirmChange() {
    this.syncConfirm()
  }

  syncConfirm() {
    if (!this.hasSubmitTarget) return
    const selected = this.inputTargets.find((el) => el.checked)
    if (!selected) return
    const intentChanged = this.normalize(selected.value) !== this.normalize(this.currentValue)
    if (intentChanged) {
      this.submitTarget.dataset.turboConfirm =
        `Changing your country will update your billing currency. Existing invoices won't be affected. Continue?`
    } else {
      delete this.submitTarget.dataset.turboConfirm
    }
  }

  // The "INTL" sentinel maps to CA on the server; reflect that here so
  // International → Canada (or vice versa) doesn't prompt.
  normalize(value) {
    return value === "INTL" ? "CA" : value
  }
}
